import { useState, useEffect } from 'react';
import { fetchNaviFlashLoanFeeForCoinType } from '../utils/flashRepayUtils';
/**
 * Returns Navi flash loan fee for the repay coin type (per Navi docs: getAllFlashLoanAssets → flashloanFee).
 * No default: feeDecimal is null until loaded or when Navi returns no fee. Use for getMaxRepayByCollateral and TokenActionModal.
 */
export function useNaviFlashLoanFee(coinType) {
    const [feeDecimal, setFeeDecimal] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (!coinType) {
            setFeeDecimal(null);
            setIsLoading(false);
            return;
        }
        let cancelled = false;
        setIsLoading(true);
        fetchNaviFlashLoanFeeForCoinType(coinType)
            .then((fee) => {
            if (!cancelled) {
                setFeeDecimal(fee);
                setIsLoading(false);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setFeeDecimal(null);
                setIsLoading(false);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [coinType]);
    return { feeDecimal, isLoading };
}
